import { ReactNode } from "react";

interface TextFieldProps {
  name: string;
  defaultValue?: string;
  placeholder?: string;
  icon?: ReactNode;
  disabled?: boolean;
}

const TextField: React.FunctionComponent<TextFieldProps> = ({
  name,
  defaultValue,
  icon,
  disabled,
  placeholder
}) => {
  
  return (
    <div className="relative">
      {icon && (
        <div className={"input-icon" + (disabled ? " disabled" : "")}>
          {icon}
        </div>
      )}

      <input
        type="text"
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        className="input-field"
        defaultValue={defaultValue}
      />
    </div>
  );
};

export default TextField;